import React, { useEffect } from 'react';
import './pages/MainPage/styles.styl';
import AppRouter from './components/AppRouter';
import Header from './components/Header';
import { useShallowEqualSelector } from './customHooks/useShallowEqualSelector';
import { State } from './redux/reducer';
import { initKeycloakSelector } from './redux/features/initilizationKeycloak/selectors';
import UserService from './services/UserService';
import { useDispatch } from 'react-redux';
import { loadUserInit } from './redux/features/userInit/actions';
import { shouldLoadUserInitSelector } from './redux/features/userInit/selectors';
import { loadCurrentUsers } from './redux/features/users/currentUsers/actions';
import {
  currentUsersLoadedSelector,
  shouldCurrentUsersSelector,
} from './redux/features/users/currentUsers/selectors';

const App = () => {
  const dispatch = useDispatch();

  const [initKeycloak, shouldUserInit, shouldCurrentUser] =
    useShallowEqualSelector((state: State) => [
      initKeycloakSelector(state),
      shouldLoadUserInitSelector(state),
      shouldCurrentUsersSelector(state),
      currentUsersLoadedSelector(state),
    ]);

  useEffect(() => {
    UserService.initKeycloak(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    shouldUserInit && initKeycloak && dispatch(loadUserInit());
    shouldCurrentUser && initKeycloak && dispatch(loadCurrentUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initKeycloak, shouldUserInit, shouldCurrentUser]);

  return (
    initKeycloak && (
      <>
        <Header />
        <AppRouter />
      </>
    )
  );
};

export default App;
